import React, { memo } from "react";
import AdSlot, { AdItem } from "@/components/ads/AdSlot";
import AdsCarousel from "@/components/ads/AdsCarousel";

interface AdsBlockProps {
  items?: AdItem | AdItem[];
  className?: string;
  rounded?: boolean;
}

/**
 * AdsBlock - Render helper
 * - Jika diberikan array > 1 => tampilkan carousel
 * - Jika satu item => tampilkan AdSlot
 */
const AdsBlock: React.FC<AdsBlockProps> = ({ items, className = "", rounded = true }) => {
  if (!items) return null;
  const list = Array.isArray(items) ? items : [items];
  if (list.length === 0) return null;

  if (list.length > 1) {
    return <AdsCarousel items={list} className={className} rounded={rounded} />;
  }

  return <AdSlot {...list[0]} className={className} rounded={rounded} />;
};

export default memo(AdsBlock, (prevProps, nextProps) => {
  // Custom comparison for better performance
  const prevItems = Array.isArray(prevProps.items) ? prevProps.items : [prevProps.items];
  const nextItems = Array.isArray(nextProps.items) ? nextProps.items : [nextProps.items];

  return (
    prevProps.className === nextProps.className &&
    prevProps.rounded === nextProps.rounded &&
    JSON.stringify(prevItems) === JSON.stringify(nextItems)
  );
});
export type { AdsBlockProps };

